import React, { Suspense } from "react";
import { Spin } from "antd";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import BranchOfficesGrid from "../../../container/branchOffices/grid";

const BranchOfficeRoutes = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <Route exact path={`${path}/`} component={BranchOfficesGrid} />
      </Suspense>
    </Switch>
  );
};

export default BranchOfficeRoutes;
